<template>

  <el-form label-position="left" label-width="auto" size="small">
    <el-collapse :accordion="true">
      <chart-title :element="element"></chart-title>
      <chart-sub-title :element="element"></chart-sub-title>
      <chart-legend :element="element"></chart-legend>
      <el-collapse-item title="绘制" name="绘制">
        <el-form-item label="类型">
          <el-select v-model="ele.option.radar.shape">
            <el-option label="多边形" value="polygon"></el-option>
            <el-option label="圆形" value="circle"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="面积图">
          <el-switch v-model="ele.option.area" active-color="#55aaff" inactive-color="#cfcfcf" @change="handleChangeArea"></el-switch>
        </el-form-item>

        <el-form-item label="轴线">
          <el-switch v-model="ele.option.radar.axisLine.show" active-color="#55aaff"
                     inactive-color="#cfcfcf">
          </el-switch>
        </el-form-item>

        <el-form-item label="x轴偏移">
          <el-input v-model="ele.option.radar.center[0]"></el-input>
        </el-form-item>

        <el-form-item label="y轴偏移">
          <el-input v-model="ele.option.radar.center[1]"></el-input>
        </el-form-item>

        <el-form-item label="内半径">
          <template #label>
            内半径
            <el-tooltip effect="dark" placement="bottom-start">
              <template #content>
                数值：例如，10 直接指定内半径值。<br>
                百分比：例如，'20%'，表示内半径为可视区尺寸的 20% 长度。
              </template>
              <el-button type="text" icon="el-icon-s-help"></el-button>
            </el-tooltip>
          </template>
          <el-input v-model="ele.option.radar.radius[0]"></el-input>
        </el-form-item>

        <el-form-item label="外半径">
          <template #label>
            外半径
            <el-tooltip effect="dark" placement="bottom-start">
              <template #content>
                数值：例如，10 直接指定外半径值。<br>
                百分比：例如，'20%'，表示外半径为可视区尺寸的 20% 长度。
              </template>
              <el-button type="text" icon="el-icon-s-help"></el-button>
            </el-tooltip>
          </template>
          <el-input v-model="ele.option.radar.radius[1]"></el-input>
        </el-form-item>

        <el-form-item label="角度">
          <el-slider v-model="ele.option.radar.startAngle" :min="-90" :max="90"></el-slider>
        </el-form-item>

      </el-collapse-item>
      <el-collapse-item title="指示器" name="指示器名称">

        <el-form-item label="显示">
          <el-switch v-model="ele.option.radar.axisName.show" active-color="#55aaff"
                     inactive-color="#cfcfcf">
          </el-switch>
        </el-form-item>

        <el-form-item label="模板">
          <template #label>
            标签模板
            <el-tooltip effect="dark" placement="bottom-start">
              <template #content>
                使用字符串模板，模板变量为刻度默认标签 {value}
              </template>
              <el-button type="text" icon="el-icon-s-help"></el-button>
            </el-tooltip>
          </template>
          <el-input v-model="ele.option.radar.axisName.formatter"></el-input>
        </el-form-item>

        <el-form-item label="距离">
          <template #label>
            距离
            <el-tooltip effect="dark" placement="bottom-start">
              <template #content>
                指示器名称和指示器轴的距离
              </template>
              <el-button type="text" icon="el-icon-s-help"></el-button>
            </el-tooltip>
          </template>
          <el-input-number v-model="ele.option.radar.nameGap"></el-input-number>
        </el-form-item>

        <el-form-item label="字体大小">
          <el-input-number v-model="ele.option.radar.axisName.fontSize"></el-input-number>
        </el-form-item>

        <el-form-item label="字体样式">
          <el-select v-model="ele.option.radar.axisName.fontStyle">
            <el-option label="普通" value="normal"></el-option>
            <el-option label="倾斜" value="italic"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="字体粗细">
          <el-select v-model="ele.option.radar.axisName.fontWeight">
            <el-option label="细的" value="lighter"></el-option>
            <el-option label="普通" value="normal"></el-option>
            <el-option label="粗的" value="bold"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="字体颜色">
          <el-color-picker v-model="ele.option.radar.axisName.color" show-alpha
                           :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']">
          </el-color-picker>
        </el-form-item>

        <el-form-item label="字体背景色">
          <el-color-picker v-model="ele.option.radar.axisName.backgroundColor" show-alpha
                           :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']">
          </el-color-picker>
        </el-form-item>

        <el-form-item label="字体内边距">
          <el-slider v-model="ele.option.radar.axisName.padding" :min="0" :max="20"></el-slider>
        </el-form-item>

      </el-collapse-item>
      <el-collapse-item title="刻度" name="刻度">
        <el-form-item label="显示">
          <el-switch v-model="ele.option.radar.axisLabel.show" active-color="#55aaff"
                     inactive-color="#cfcfcf">
          </el-switch>
        </el-form-item>

        <el-form-item label="刻度角度">
          <el-slider v-model="ele.option.radar.axisLabel.rotate" :min="-90" :max="90"></el-slider>
        </el-form-item>

        <el-form-item label="刻度颜色">
          <el-color-picker v-model="ele.option.radar.axisLabel.color" show-alpha
                           :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']">
          </el-color-picker>
        </el-form-item>

      </el-collapse-item>
    </el-collapse>
  </el-form>

</template>

<script>
import ChartTitle from "@/components/design-report/chart/chartStyle/chartTitle.vue";
import ChartSubTitle from "@/components/design-report/chart/chartStyle/chartSubTitle.vue";
import ChartLegend from "@/components/design-report/chart/chartStyle/chartLegend.vue";

export default {
  components: {ChartLegend,   ChartSubTitle, ChartTitle},
  props: {
    element: {
      type: Object,
      default: () => {
      }
    },
    report: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },
  methods: {
    handleChangeArea(flag){
      this.ele.option.series.forEach(item=>{
        if(flag){
          item.areaStyle = {opacity: 0.5}
        }else{
          delete item.areaStyle;
        }
      })
    },
  }


}

</script>

<style scoped lang="scss">

</style>